
import { Alert } from "../Alert";
import _ from "lodash";

/*
 * We use this to add some error-catching functionality to the given wrapper.
 *
 * If this pattern looks odd to you, lookup "javascript decorators" and "javascript composition".
 *
 * I wrote this primarily so we don't need to write network error handling objects for each
 * type of object when they are saved to the API.
 *
 * 
 *  A standard use case:
 *
 *  import TimesheetApi from "../../util/api/TimesheetApi";
 *  import ApiMixin from "./ApiMixin";
 *  Timesheet {
 *      [...] //Other logic here.
 *
 *      save(timesheet) {
 *          let api = ApiMixin(TimesheetApi)
 *          
 *          [...]
 *      }
 *  }
 * 
*/

export const ApiMixin = (ApiObject) => {
    return {

        async add(item) {
            console.log("add");
            let response = await ApiObject.add(item);



            return response;
        },

        async update(item) {
            console.log("update");
            let response = await ApiObject.update(item);

            console.log(response);
            return response;
        },

        /*
         * This function determines if we are saving or updating a wrapper object,
         * chooses the appropriate function to call, and handles network errors.
         */
        async save(item) {
            let response = {};

            let retval = {
                errors: [],
                data: {}
            };

            try {
                //We are updating if the item already has an ID.
                if (item.id) {
                    response = await this.update(item);

                    retval.data = response.data;
                }
                //If not, we're going to add it using the API
                else {
                    response = await this.add(item);

                    retval.data = response.data;
                }
            }
            catch(error) { 
                console.log(error);
                console.log(JSON.stringify(error));

                console.log(error.response);

                //A response has been recieved from the server.
                if (error.response) {

                    //If it is a validation error generated by entity framework 
                    if (error.response.data.errors) {
                        //Loop through and add alerts to retval
                        _.forEach(error.response.data.errors, (errorText) => {

                            let alert = new Alert("Validation error", errorText, "error", error.response.data.title);

                            retval.errors.push(alert);
                        });
                    }

                    //Some other error response. 
                    else {
                        console.log(error.response.data)
                        let alert = new Alert("An error occurred", error.response.data.title);

                        retval.errors.push(alert);
                    }
                }
                //An error unrelated to the server (a timeout)  
                else {
                    let alert = new Alert("Network Error", error.message);
                    retval.errors.push(alert);
                }
                return retval;
            }

            //Occassional the error is custom data validation, not an error response.
            if (response.data && response.data.errors) {
                retval.errors = response.data.errors;
            }

            return retval;
        }
    }
}



